import ExclusionOverlayDialog from '@views/admin/investor-eligibility/components/ExclusionOverlayDialog';


export const overlayDialogRoutes = {
    'overlays/add': ExclusionOverlayDialog,
    'overlays/:overlayID/edit': ExclusionOverlayDialog
};
